import { ToastContainer } from "react-toastify";
import { Outlet } from "react-router-dom";
import { useT } from "../../stores/uiLang";
import { PE_T } from "../../i18n/peLesson";
import { Header } from "../sections/Header";
import CookieConsentBanner from "../CookieConsentBanner";

export function DashboardLayout() {
  // Run E2 J5: the toast region's screen-reader label follows the UI language.
  const t = useT(PE_T);
  return (
    <div>
      <ToastContainer aria-label={t.notificationsAria} />
      <Header />
      <main className="">
        <Outlet />
      </main>
      <CookieConsentBanner />
    </div>
  );
}
